import { useCallback, useEffect } from 'react';
import { usePlayerContext } from '../../ui-react/PlayerContext';
import { PlayerInWindow } from '../../ui-react/icons';
import { Tooltip } from '../../ui-react/controls/Tooltip';
import styles from './PlayerInWindowBtn.module.css';

const WIN_PARAMS = 'height=450,width=800,location=0,menubar=0,resizable=1,scrollbars=0,status=0';
export function PlayerInWindowBtn() {
  const { store, eventBus, config } = usePlayerContext();

  const handleClick = useCallback(() => {
    const streamKey = store.getState().streamKey || config.streamKey;
    const playerUrl = `/player?${encodeURIComponent(streamKey)}`;
    window.open(playerUrl, 'player', WIN_PARAMS);

    eventBus.emit('pause');
  }, [store, eventBus, config]);

  useEffect(() => {
    return eventBus.on('player-in-window:open', handleClick);
  }, [eventBus, handleClick]);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.btn}
        onClick={handleClick}
      >
        <span><PlayerInWindow /></span>
      </button>
      <Tooltip label="Плеер в окне" shortcut="i" />
    </div>
  );
}
